var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('model-performance-summary',{attrs:{"models":_vm.related_models,"threshold":_vm.threshold,"related_jobs":_vm.related_active_jobs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }